import { useAuth } from '@clerk/clerk-react';

/**
 * Returns true if the current Clerk session holds `permission` for the active
 * organisation, false otherwise.
 *
 * Unify's Clerk app emits v2 session tokens (the org context is nested under
 * the `o` claim and permissions are encoded as a bitmap). Clerk's `has()`
 * helper normalises across v1 and v2 transparently, so we just call through.
 *
 * Falls back to `false` while the session is still loading — pages should
 * default-deny so action buttons stay disabled until the claim is verified.
 */
export function useCheckPermission(permission) {
	const { isLoaded, has } = useAuth();
	if (!isLoaded || typeof has !== 'function') return false;
	try {
		return Boolean(has({ permission }));
	} catch {
		return false;
	}
}
